<template>
    <div class="modal modal-blur fade" id="modal-account" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Glasfaser-Bestellung</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info" role="alert">
                        Du bist als {{ customer.display_name }} angemeldet und bestellst als {{ customer.business ? 'Businesskunde' : 'Privatkunde' }}.
                    </div>
                    <template v-if="step=='data'">
                        <p>Wir benötigen noch einige Informationen, um die Bestellung ausführen zu können.</p>
                        <label class="form-label font-weight-bold">Anschlussadresse - Straße*</label>
                        <div class="row mb-2">
                            <div class="col-9">
                                <input placeholder="Straße" class="form-control" v-model="street" name="street" type="text">
                                <div class="invalid-feedback"></div>
                            </div>
                            <div class="col-3">
                                <input placeholder="Nr." class="form-control" v-model="streetNumber" name="street_number" type="text">
                                <div class="invalid-feedback"></div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label font-weight-bold">Anschlussadresse - Gemeinde*</label>
                            <select class="form-select " name="community" v-model="communityId">
                                <option :value="null">Bitte wählen...</option>
                                <option v-for="community in communities"  :value="community.id" :key="community.id">{{ community.name }}</option>
                            </select>
                        </div>
                        <div class="mb-1">
                            <template v-if="selectedCommunityId && customer.community_id != selectedCommunityId">
                                <a href="#" @click.prevent="copyAddressFromSelectionAddress">Anschlussgemeinde von Auswahl übernehmen</a><br>
                            </template>
                            <a href="#" @click.prevent="copyAddressFromInvoiceAddress">Anschlussadresse von Rechnungsadresse übernehmen</a>
                        </div>
                        <template>
                            <hr class="my-2">
                            <label class="form-label font-weight-normal">Ansprechpartner für die Installation*</label>
                            <div class="row mb-2">
                                <div class="col-6">
                                    <input placeholder="Vorname" class="form-control" v-model="firstname" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="col-6">
                                    <input placeholder="Nachname" class="form-control" v-model="lastname" type="text">
                                    <div class="invalid-feedback"></div>
                                </div>
                            </div>
                            <label class="form-label font-weight-normal">E-Mail Adresse für Rückfragen*</label>
                            <input placeholder="E-Mail" class="form-control mb-2" v-model="email" type="email">

                            <label class="form-label font-weight-normal">Telefonnummer für Rückfragen*</label>
                            <input placeholder="Telefonnummer" class="form-control mb-2" v-model="phone" type="text">

                        </template>
                        <hr class="my-3">
                        <div class="mb-2">
                            <b>Rechnungsadresse</b><br>
                            {{ customer.name }}<br>
                            {{ customer.street }} {{ customer.street_number }}<br>
                            {{ customer.community_plz }} {{ customer.community_name }}<br>
                            Str.Nr.: {{ customer.tax_number }}<br>
                            <template v-if="customer.business">
                            MwStr.Nr.: {{ customer.vat_number }}<br>
                            </template>
                            Zahlung: SEPA Bankeinzug ({{ customer.bank_iban }})<br>
                            <small>Die Rechnungsadresse ist mit deinem Kundenaccount verknüpft.</small>
                        </div>
                    </template>
                    <template v-else>
                        <p>Bitte prüfe die eingegebenen Daten auf Richtigkeit.</p>

                        <div class="mb-2" v-if="selectedProduct">
                            <b>Paket {{ selectedProduct.short }}</b><br>
                            {{ selectedProduct.name }}<br>
                            <template v-if="community && ['Bruneck', 'Gais', 'Percha'].includes(community.name)">
                                {{ selectedProduct.down_swbk }} Mbit/s Download - {{ selectedProduct.up_swbk }} Mbit/s Upload<br>
                            </template>
                            <template v-else>
                                {{ selectedProduct.down }} Mbit/s Download - {{ selectedProduct.up }} Mbit/s Upload<br>
                            </template>
                            <template v-if="selectedProduct.static_ip">statische IP-Adresse<br></template>
                            Monatliche Gebühren: {{ selectedProduct.monthly_fee }} pro Monat<br>
                            Aktivierung: {{ selectedProduct.setup_fee }} einmalig<br>
                            Vertragsbindung 24 Monate<br>
                        </div>

                        <div class="alert alert-warning">
                            <small>
                                In bestimmten (Wholesale) Gemeinden fällt ein Aufpreis von 10,00 € pro Monat an. Falls dies für deinen Anschluss zutrifft werden wir dich kontaktieren. Leider können wir dies oft erst nach Prüfung deiner Anschlussadresse feststellen.
                            </small>
                            <template v-if="['Sterzing', 'Meran'].includes(community.name) && selectedProduct.vertical_cable_fee">
                                <br><br>
                                <small>
                                    Für die Gemeinde {{ community.name }} (Pilotprojekt Infranet) können einmalige Zusatzkosten von {{ selectedProduct.vertical_cable_fee | currency }} {{  customer.business ? 'inkl.' : 'exkl.' }} MwStr. für die interne Verlegung der Glasfaserlinie durch die Infranet anfallen.
                                </small>
                            </template>
                        </div>


                        <div class="mb-2" v-if="community">
                            <b>Anschlussadresse</b><br>
                            {{ street }} {{ streetNumber }}<br>
                            {{ community.plz }} {{ community.name }}<br>
                        </div>

                        <div class="mb-2">
                            <b>Rechnungsadresse</b><br>
                            {{ customer.name }}<br>
                            {{ customer.street }} {{ customer.street_number }}<br>
                            {{ customer.community_plz }} {{ customer.community_name }}<br>
                            Str.Nr.: {{ customer.tax_number }}<br>
                            <template v-if="customer.business">
                            MwStr.Nr.: {{ customer.vat_number }}<br>
                            </template>
                            Zahlung: SEPA Bankeinzug ({{ customer.bank_iban }})<br>
                            <small>Die Rechnungsadresse ist mit deinem Kundenaccount verknüpft.</small>
                        </div>

                        <hr>
                        <label class="form-label">Optionale Bemerkung</label>
                        <textarea class="form-control" rows="3" v-model="notes"></textarea>
                        <label class="form-check mt-3">
                            <input class="form-check-input" v-model="agb" type="checkbox" :value="true">
                            <span class="form-check-label"> Ich habe die <a href="/agb" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere diese.</span>
                        </label>
                    </template>


                </div>
                <div class="modal-footer">
                    <a href="#" class="btn btn-outline-danger" v-if="step=='data'" data-bs-dismiss="modal">
                        Abbrechen
                    </a>
                    <a href="#" class="btn btn-outline-danger" v-if="step=='confirm'" @click.prevent="step='data'">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="5" y1="12" x2="9" y2="16" /><line x1="5" y1="12" x2="9" y2="8" /></svg>
                        zurück
                    </a>
                    <a href="#" class="btn btn-primary ms-auto" v-if="step=='data'" @click.prevent="nextStep">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /><line x1="15" y1="16" x2="19" y2="12" /><line x1="15" y1="8" x2="19" y2="12" /></svg>
                        Daten prüfen
                    </a>
                    <a href="#" class="btn btn-primary ms-auto" v-else-if="step=='confirm'" @click.prevent="nextStep">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <line x1="10" y1="14" x2="21" y2="3" />
                            <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
                        </svg>
                        Bestellung senden
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    export default {
        props: ['customer', 'communities', 'products', 'selectedCommunityId'],
        mounted() {
            this.copyCustomerData()
        },
        data() {
            return {
                agb: false,
                street: null,
                streetNumber: null,
                communityId: null,
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                step: 'data',
                notes: null,
            }
        },
        computed: {
            community: function() {
                return this.communities.find(item => {
                    return item.id==this.communityId
                })
            },
            selectedProduct: function() {
                if(this.$root.selectedProduct) {
                    return this.products.find(item => {
                        return item.short==this.$root.selectedProduct
                    })
                }
                return null
            }
        },
        methods: {
            copyCustomerData: function() {
                this.firstname = this.customer.firstname;
                this.lastname = this.customer.lastname;
                this.phone = this.customer.phone;
                this.email = this.customer.email;
            },
            nextStep: function() {
                if(this.step=='data') {
                    var check = true;
                    if(this.street == null || this.street.length==0) {
                        check = false;
                    }
                    if(this.streetNumber == null || this.streetNumber.length==0) {
                        check = false;
                    }
                    if(this.communityId == null || this.communityId.length==0) {
                        check = false;
                    }
                    if(this.firstname == null || this.firstname.length==0) {
                        check = false;
                    }
                    if(this.lastname == null || this.lastname.length==0) {
                        check = false;
                    }
                    if(this.email == null || this.email.length==0) {
                        check = false;
                    }
                    if(this.phone == null || this.phone.length==0) {
                        check = false;
                    }
                    if(check==false) {
                        Swal.fire({
                            title: 'Fehler',
                            text: `Bitte gib die Anschlussadresse und den Ansprechspartner an!`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return;
                    }

                    this.step = 'confirm';
                    return;
                }

                if(this.step=='confirm') {
                    if(!this.agb) {
                        Swal.fire({
                            title: 'Fehler',
                            text: `Bitte akzeptiere die AGBs!`,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                        return
                    }

                    Swal.fire({
                        title: 'Glasfaser-Bestellung',
                        text: `Möchtest du die Bestellung wirklich absenden?`,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Ja',
                        confirmButtonColor: '#6bc100',
                        cancelButtonText: 'Abbrechen',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.fire({
                                title: 'Glasfaser-Bestellung',
                                text: 'Bitte um einen Moment Geduld - die Bestellung wird gerade versendet.',
                                allowOutsideClick: false,
                                showCancelButton: false,
                                showConfirmButton: false,
                                onBeforeOpen: () => {
                                    Swal.showLoading()
                                },
                            });
                            var postData = {
                                street: this.street,
                                firstname: this.firstname,
                                lastname: this.lastname,
                                email: this.email,
                                phone: this.phone,
                                streetNumber: this.streetNumber,
                                community: this.community,
                                product: this.selectedProduct,
                                notes: this.notes,
                                customer: this.customer
                            }
                            axios.post('/api/backend/order/fiber', postData)
                                .then((response) => {
                                    console.log(response)
                                    jQuery('#modal-account').modal('hide');
                                    this.street = null;
                                    this.streetNumber = null;
                                    this.communityId = null;
                                    this.agb = false;
                                    this.step = 'data';
                                    this.notes = null;
                                    window.vueApp.selectedProduct = null;
                                    this.copyCustomerData()
                                    Swal.fire(
                                        'Glasfaser-Bestellung',
                                        'Vielen Dank für deine Bestellung! Ein Mitarbeiter wird sich bald bei dir melden.',
                                        'success'
                                    )
                                }).catch( (error) => {
                                    Swal.fire(
                                        'Glasfaser-Bestellung',
                                        'Es ist ein Fehler beim Absenden der Bestellung aufgetreten! Bitte versuche es später nocheinmal oder kontaktiere uns.',
                                        'error'
                                    )
                                });
                        }
                    })
                }
            },
            copyAddressFromInvoiceAddress: function() {
                this.communities.forEach(item => {
                    if(item.id == this.customer.community_id) {
                        this.communityId = this.customer.community_id;
                    }
                })
                if(this.communityId==null) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `In der Gemeinde ${this.customer.community_name} ist leider kein Glasfaser verfügbar. Gerne geben unsere Mitarbeiter auskunft über den Status in dieser Gemeinde.`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return;
                }
                this.street = this.customer.street;
                this.streetNumber = this.customer.street_number;
            },

            copyAddressFromSelectionAddress: function() {
                this.communities.forEach(item => {
                    if(item.id == this.selectedCommunityId) {
                        this.communityId = this.selectedCommunityId
                    }
                })
                if(this.communityId==null) {
                    Swal.fire({
                        title: 'Fehler',
                        text: `In der Gemeinde ${this.customer.community_name} ist leider kein Glasfaser verfügbar. Gerne geben unsere Mitarbeiter auskunft über den Status in dieser Gemeinde.`,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                    return;
                }
                this.street = ''
                this.streetNumber = ''
            }
        }
    }
</script>
